<template>
  <div class="login-page">
    <div class="login-framework">
      <el-container class="login-container">
        <el-header class="header">
          <img src="/static/login/logo.png" height="80px"/>
        </el-header>
        <el-main class="main">
          <el-card shadow="always" class="form-box" :body-style="{ padding:'20px'}">
            <div class="card-body">
              <div class="user">
                <p class="name">电子邮箱
                  <span class="warn">{{ emailWarn }}</span>
                </p>
                <el-input size="large" v-model="email" class="input-box" placeholder="blackbox@exmaple.com"
                          @blur="showEmailTips"></el-input>
              </div>
              <div class="pwd">
                <p class="name">密码
                  <span class="warn">{{ pwdWarn }}</span>
                </p>
                <el-input size="large" v-model="pwd" class="input-box" type="password" placeholder="请输入密码"
                          @blur="showPwdTips"></el-input>
              </div>
              <el-button type="primary" class="login-button" @click="toLogin">
                <span style="font-size:14px">登录</span>
              </el-button>
            </div>
          </el-card>
        </el-main>
        <el-footer class="bottom">
          <el-card shadow="always" :body-style="{ padding:'15px'}">
            <span class="bottom-text">第一次使用？
            <a href="/#/register" target="_parent" title="点击此处注册" style="font-size: 14px;color:#2258cc">点击此处注册</a>
            </span>
          </el-card>
        </el-footer>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login-page',
  data() {
    return {
      email: '',
      pwd: '',
      emailWarn: '',
      pwdWarn: '',
    };
  },
  inject: ['reload'],
  created() {
    const self = this;
    document.onkeydown = function () {
      const key = window.event.keyCode;
      if (key === 13) {
        self.toLogin();
      }
    };
  },
  mounted() {
    if (this.$store.getters.getLoginInfo.success === true) {
      setTimeout(() => this.reload(), 500);
      this.$notify({
        title: '身份过期提示',
        message: `${this.$store.getters.getLoginInfo.data.username}，您的身份已过期，请重新登录`,
        type: 'error',
      });
    }
    // 每次进入登录界面时，清空此前登录信息
    this.$store.commit('setLoginInfo', { data: { status: false, userName: '' } });
  },
  methods: {
    showEmailTips() {
      if (this.email === '') {
        this.emailWarn = '请输入电子邮箱';
      } else if (this.isEmail(this.email) === false) {
        this.emailWarn = '请输入正确的电子邮箱';
      } else {
        this.emailWarn = '';
      }
    },
    showPwdTips() {
      if (this.pwd === '') {
        this.pwdWarn = '请输入密码';
      } else {
        this.pwdWarn = '';
      }
    },
    toLogin() {
      const self = this;
      const { email, pwd } = this;
      self.emailWarn = '';
      self.pwdWarn = '';
      if (email === '') {
        self.emailWarn = '请输入电子邮箱';
      } else if (self.isEmail(email) === false) {
        self.emailWarn = '请输入正确的电子邮箱';
      } else if (pwd === '') {
        self.pwdWarn = '请输入密码';
      } else {
        self.$store.dispatch('confirmLoginInfo', { email, pwd })
          .then(() => {
            if (self.$store.getters.getLoginInfo.success === true) {
              self.$router.push({
                name: 'device',
              });
            } else {
              this.$message({
                type: 'error',
                message: `登录失败！
              错误码: ${self.$store.getters.getLoginInfo.errorCode}
              (${self.$store.getters.getLoginInfo.errorMsg.length === 0 ? '未知错误' :
    self.$store.getters.getLoginInfo.errorMsg})`,
              },
              );
            }
          });
      }
    },
    isEmail(mail) {
      const filter = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      if (filter.test(mail)) {
        return true;
      }
      return false;
    }
    ,
  },
};
</script>

<style lang="scss">
  @import "../style/mixin";
  @import '../style/media';

  .login-page {
    width: 100%;
    height: 100%;
    background-image: url('/static/login/demo.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    -webkit-box-orient: vertical;
    @include focus-scroll-bar;

    .login-container {
      margin-left: auto;
      margin-right: auto;
      background: #fff;
      width: 450px;
      height: 550px;
      display: flex;
      align-items: center;
      vertical-align: center;
      justify-content: center;
      overflow-x: auto;

      .header {
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-box-orient: vertical;
        text-align: center;
        height: 120px !important;
      }

      .main {
        padding: 0 !important;
        background: #fff;

        .form-box {
          width: 400px;
          height: 320px;
        }

        .card-body {
          padding: 0 !important;

          .name {
            margin-top: 8px;
            margin-bottom: 8px;
            font-size: 14px;
          }

          .input-box {
            margin-bottom: 20px;
          }

          .login-button {
            width: 100% !important;
            margin-top: 20px;
          }

          .warn {
            color: red;
            font-weight: bold;
            float: right;
          }
        }
      }

      .bottom {
        width: 400px !important;
        height: 80px !important;
        padding: 0 !important;

        .bottom-text {
          display: -webkit-box;
          -webkit-box-pack: center;
          -webkit-box-align: center;
          -webkit-box-orient: vertical;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue